import Vue from 'vue';
import App from './App.vue';
import Axios from 'axios';
import router from './router';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/my-style.css';

// Detect the app info and save it to the storage
import utils from './utils.js';
import myStore from './my-store.js';

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.prototype.$axios = Axios.create({
    baseURL: process.env.VUE_APP_SSO_API_BASE,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

Vue.prototype.$axios.interceptors.request.use(config => {
    const token = myStore.getToken();
    if (token) {
        config.headers['X-token'] = token;
    }
    return config;
}, err => {
    return Promise.reject(err);
});

Vue.prototype.$axios.interceptors.response.use(response => {
    return response;
}, err => {
    return Promise.reject(err);
});


new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
